import ServerIcon from '../../../../images/server.svg?component';
import ROUTE_NAMES from '../../routeNames';
import SECTION_NAMES from '../../sectionNames';
import { usePermissionsStore } from '@/vue/stores/permissions';

const meta = {
    title: SECTION_NAMES.SERVERS_AND_SERVICES,
    icon: ServerIcon,
    permissions: (): string[] => [usePermissionsStore().allPermissions.adminServersCalendarConfigs],
};

export default [
    {
        path: '',
        name: ROUTE_NAMES.ADMIN_CALENDAR_CONFIG_LIST,
        component: ():Promise<unknown> => import('../../../views/admin/Servers/Calendar/AdminCalendarConfigTable.vue'),
        meta,
    },
    {
        path: 'edit/:id',
        name: ROUTE_NAMES.ADMIN_CALENDAR_CONFIG_VIEW,
        component: ():Promise<unknown> => import('../../../views/admin/Servers/Calendar/AdminCalendarConfigForm.vue'),
        meta,
    },
    {
        path: 'new',
        name: ROUTE_NAMES.ADMIN_CALENDAR_CONFIG_NEW,
        component: ():Promise<unknown> => import('../../../views/admin/Servers/Calendar/AdminCalendarConfigForm.vue'),
        meta,
    },
];
